/**
 * A catch clause can be handed anything at all, while almost everything that deals with
 * the result - Sentry, the notification bar, the error callbacks - is written for an
 * Error. This is the one place that difference is resolved.
 */
export default (caught: unknown): Error => (caught instanceof Error ? caught : new Error(String(caught)));
